import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

interface FinancialAuditFilters {
  tableName?: string;
  startDate?: string;
  endDate?: string;
}

export interface FinancialAuditRow {
  id: string;
  table_name: string;
  record_id: string;
  operation: string;
  old_data: any;
  new_data: any;
  changed_by: string | null;
  changed_at: string;
}

export const useFinancialAuditLog = (filters?: FinancialAuditFilters) => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["financial_audit_log", user?.id, filters],
    queryFn: async () => {
      let query = supabase
        .from("financial_audit_log")
        .select("id, table_name, record_id, operation, old_data, new_data, changed_by, changed_at")
        .order("changed_at", { ascending: false })
        .limit(500);

      if (filters?.tableName && filters.tableName !== "all") {
        query = query.eq("table_name", filters.tableName);
      }
      if (filters?.startDate) {
        query = query.gte("changed_at", filters.startDate);
      }
      if (filters?.endDate) {
        query = query.lte("changed_at", filters.endDate + "T23:59:59");
      }

      const { data, error } = await query;
      if (error) throw error;
      return (data ?? []) as FinancialAuditRow[];
    },
    enabled: !!user,
  });
};
